import { ITourFare } from "@interfaces";
import moment from "moment";

const parseTravelMoment = (s: string) => {
    const iso = moment(s, moment.ISO_8601, true);
    if (iso.isValid()) return iso;
    const dmy = moment(s, "DD MMM YYYY", true);
    if (dmy.isValid()) return dmy;
    return moment(s);
};

const rangesOverlap = (
    aStart: moment.Moment,
    aEnd: moment.Moment,
    bStart: moment.Moment,
    bEnd: moment.Moment,
): boolean => {
    return aStart.isSameOrBefore(bEnd) && aEnd.isSameOrAfter(bStart);
};

export const getFaresForDateRange = (
    prices: ITourFare[],
    startDate: Date,
    endDate: Date,
): ITourFare[] => {
    const faresWithTravelRange = prices.filter(
        (p) => p.travelStart !== null && p.travelStart !== undefined && p.travelEnd !== null && p.travelEnd !== undefined,
    );

    if (faresWithTravelRange.length === 0) {
        return prices.length > 0 ? [prices[0]] : [];
    }

    const reqStart = moment(startDate);
    const reqEnd = moment(endDate);

    const overlapping = faresWithTravelRange.filter((fare) => {
        const fareStart = parseTravelMoment(fare.travelStart!);
        const fareEnd = parseTravelMoment(fare.travelEnd!);
        return rangesOverlap(reqStart, reqEnd, fareStart, fareEnd);
    });

    if (overlapping.length === 0) {
        return [prices[0]];
    }

    overlapping.sort((a, b) => {
        const aStart = parseTravelMoment(a.travelStart!).valueOf();
        const bStart = parseTravelMoment(b.travelStart!).valueOf();
        return aStart - bStart;
    });

    return overlapping;
};
